import { render } from "./RegisterPrivacyPolicy.vue?vue&type=template&id=bea01a5e&ts=true"
import script from "./RegisterPrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./RegisterPrivacyPolicy.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__